export default __webpack_public_path__ + "static/media/squirrel.fc2db47b.webp";